import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { supabase } from "../../supabase";
import "./MyPage.css";

export default function MyPageGallery() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [tab, setTab] = useState("my");
  const [posts, setPosts] = useState([]);
  const [likedPosts, setLikedPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) return;
    setLoading(true);

    if (tab === "my") {
      supabase
        .from("gallery")
        .select("id, title, status, reject_reason, thumbnail_url, created_at")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false })
        .then(({ data }) => {
          setPosts(data || []);
          setLoading(false);
        });
    } else {
      supabase
        .from("gallery_likes")
        .select("gallery_id, gallery:gallery_id(id, title, thumbnail_url, created_at, like_count)")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false })
        .then(({ data }) => {
          setLikedPosts((data || []).map((r) => r.gallery).filter(Boolean));
          setLoading(false);
        });
    }
  }, [user?.id, tab]);

  const statusLabel = (status) => {
    const map = {
      pending: { cls: "pending", text: t("mypage.gallery.pending") || "승인 대기" },
      approved: { cls: "approved", text: t("mypage.gallery.approved") || "승인됨" },
      rejected: { cls: "rejected", text: t("mypage.gallery.rejected") || "거절됨" },
    };
    return map[status] || map.pending;
  };

  const tabs = [
    { key: "my", label: t("mypage.gallery.myPosts") || "내 게시글" },
    { key: "liked", label: t("mypage.gallery.likedPosts") || "좋아요" },
  ];

  return (
    <div className="mypage-card">
      <h2>{t("mypage.gallery.title") || "내 갤러리"}</h2>
      <p className="mypage-desc">{t("mypage.gallery.desc")}</p>

      <div className="mg-tabs">
        {tabs.map((tb) => (
          <button
            key={tb.key}
            className={`mg-tab ${tab === tb.key ? "active" : ""}`}
            onClick={() => setTab(tb.key)}
          >
            {tb.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="mg-empty">{t("mypage.common.loading")}</div>
      ) : tab === "my" ? (
        posts.length === 0 ? (
          <div className="mg-empty">
            {t("mypage.gallery.empty") || "아직 올린 게시글이 없습니다."}
          </div>
        ) : (
          <div className="mg-list">
            {posts.map((post) => {
              const s = statusLabel(post.status);
              return (
                <div
                  key={post.id}
                  className="mg-item"
                  onClick={() => history.push(`/gallery/${post.id}`)}
                >
                  <div className="mg-thumb">
                    {post.thumbnail_url ? (
                      <img src={post.thumbnail_url} alt="" />
                    ) : (
                      <div className="mg-thumb-empty" />
                    )}
                  </div>
                  <div className="mg-info">
                    <div className="mg-title">{post.title}</div>
                    <div className="mg-date">
                      {new Date(post.created_at).toLocaleDateString()}
                    </div>
                    {post.status === "rejected" && post.reject_reason && (
                      <div className="mg-reason">사유: {post.reject_reason}</div>
                    )}
                  </div>
                  <div className={`mg-status ${s.cls}`}>{s.text}</div>
                </div>
              );
            })}
          </div>
        )
      ) : likedPosts.length === 0 ? (
        <div className="mg-empty">
          {t("mypage.gallery.likedEmpty") || "좋아요한 게시글이 없습니다."}
        </div>
      ) : (
        <div className="mg-list">
          {likedPosts.map((post) => (
            <div
              key={post.id}
              className="mg-item"
              onClick={() => history.push(`/gallery/${post.id}`)}
            >
              <div className="mg-thumb">
                {post.thumbnail_url ? (
                  <img src={post.thumbnail_url} alt="" />
                ) : (
                  <div className="mg-thumb-empty" />
                )}
              </div>
              <div className="mg-info">
                <div className="mg-title">{post.title}</div>
                <div className="mg-date">
                  {new Date(post.created_at).toLocaleDateString()}
                </div>
              </div>
              <div className="mg-like-badge">♥ {post.like_count || 0}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
